// extracted by mini-css-extract-plugin
module.exports = {"sticky":"ArticleSticky_sticky_5p6Iq"};